// extracted by mini-css-extract-plugin
var _1 = "HxsTJ";
export { _1 as "inputGroup" }
